import React from "react";
import ApiDetailHeader from "../ApiDetailHeader";
import SchemaContainer from "../SchemaContainer/SchemaContainer";
import {extractTitleAndSchemaId} from "../../utils/helpers";
const MethodContainer = ({groupedByTags, schemas, schemasWithRefs, navIndex, component}) => {
  return (
    <>
      {groupedByTags.map(({name, description, tags, id}, entityIndex)=>{
        return (tags.length>1 && groupedByTags.length>1) ? (
          <>
            <div className="main-section">
              <h1 className="header" id={`${id}`} data-menu-index={entityIndex} data-open-index={navIndex} data-id={name} data-subMenu-index="0">{name}</h1>
              <p className="header1-description">{description}</p>
            </div>
            {tags.map(({name, description, paths, id}, subEntityIndex)=>{
              return <>
                <ApiDetailHeader navIndex={navIndex} entityIndex={entityIndex} subEntityIndex={subEntityIndex} key={`${name}${subEntityIndex}`} name={name} description={description} paths={paths} schemas={schemas} id={id}/>
              </>;
            })}
          </>
        ) :( tags.map(({name, description, paths, id}, subEntityIndex)=>{
          return <>
            <ApiDetailHeader navIndex={navIndex} entityIndex={entityIndex} subEntityIndex={subEntityIndex} key={`${name}${subEntityIndex}`} name={name} description={description} paths={paths} id={id} schemas={schemas}/>
          </>;
        }));
      })}
      {component === "SinglePage" && (
        <div className="main-section schema-heading" id="schemas" data-id="schemas">
          <h1 id="internal-mobility-api-schemas">Schemas</h1>
        </div>
      )}
      {component === "SinglePage" && schemas.map((item, index)=>{
        const {title, uniqueSchemaId}=extractTitleAndSchemaId(item);
        const propertiesTableData = schemasWithRefs[index][1];
        return (
          <SchemaContainer
            schemas={schemas}
            navIndex={navIndex}
            key={item[0]}
            title={title} id={uniqueSchemaId} propertiesTableData={propertiesTableData} requestBody={Object.values(item[1])[0]} schemaIndex={index}
          />
        );
      })}
    </>
  );
};

export default MethodContainer;
